import * as React from 'react';
import { Helmet } from "react-helmet";
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Home from "@components/Home";

export interface Props extends RouteComponentProps { }

const HomeContainer: React.SFC<Props> = (props: Props) => {
    const title = 'Nick Avasiloi - About me | Full Stack Web Developer, Artificial Intelligence Specialist';
    const description = 'Introduction about techincal experince in various information technology areas';
    const url = process.env.REACT_APP_URL + props.location.pathname;

    return (
        <>
            <Helmet>
                <style>{'body { overflow: hidden; }'}</style>
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta name="og:title" content={title} />
                <meta name="og:description" content={description} />
                <meta name="og:url" content={url} />
            </Helmet>
            <Home />
        </>
    );
}

const HomeContainerRouted = withRouter(HomeContainer);
export default HomeContainerRouted;


// WEBPACK FOOTER //
// ./src/containers/Home/index.tsx